import { Pipe, PipeTransform } from '@angular/core';
import { ITEM } from '@utils/constants';

@Pipe({
    name: 'masking',
    standalone: true
})

export class NumberMaskingPipe implements PipeTransform {
    transform(value: string): string {
        const DEFAULT_HALF_MASK_LENGTH = 2;
        const DIVISION_FACTOR = 2;

        if (!value) {
            return '';
        }

        const halfMaskLength = DEFAULT_HALF_MASK_LENGTH;
        const maskStandardIndex = Math.ceil(value.length / DIVISION_FACTOR) - halfMaskLength;
        const mask = '*'.repeat(halfMaskLength * DIVISION_FACTOR);

        return value.slice(ITEM.START_INDEX, maskStandardIndex) + mask + value.slice(maskStandardIndex + mask.length);
    }
}
